import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class RDDV2FormFileModel extends ModelBase<RDDV2FormFileModel> {
    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_RDDV2_ID = "";
    public static readonly DEFAULT_RDDV2_CATEGORY_ID = "";
    public static readonly DEFAULT_FILENAME = "";
    public static readonly DEFAULT_FILEURL = "";
    public static readonly DEFAULT_CREATED_BY_USER_ID = null;
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_UNIQUE_ID = "";

    @observable
    public id: string | null = RDDV2FormFileModel.DEFAULT_ID;
    @observable
    public rddV2Id: string = RDDV2FormFileModel.DEFAULT_RDDV2_ID;
    @observable
    public rddV2CategoryId: string = RDDV2FormFileModel.DEFAULT_RDDV2_CATEGORY_ID;
    @observable
    public fileName: string = RDDV2FormFileModel.DEFAULT_FILENAME;
    @observable
    public fileURL: string = RDDV2FormFileModel.DEFAULT_FILEURL;
    @observable
    public createdByUserId: string | null = RDDV2FormFileModel.DEFAULT_CREATED_BY_USER_ID;
    @observable
    public isDeleted: boolean = RDDV2FormFileModel.DEFAULT_IS_DELETED;
    @observable
    public uniqueId: string | null = RDDV2FormFileModel.DEFAULT_UNIQUE_ID;

    @action
    public reset = () => {
        this.id = RDDV2FormFileModel.DEFAULT_ID;
        this.rddV2Id = RDDV2FormFileModel.DEFAULT_RDDV2_ID;
        this.rddV2CategoryId = RDDV2FormFileModel.DEFAULT_RDDV2_CATEGORY_ID;
        this.fileName = RDDV2FormFileModel.DEFAULT_FILENAME;
        this.fileURL = RDDV2FormFileModel.DEFAULT_FILEURL;
        this.createdByUserId = RDDV2FormFileModel.DEFAULT_CREATED_BY_USER_ID;
        this.isDeleted = RDDV2FormFileModel.DEFAULT_IS_DELETED;
        this.uniqueId = RDDV2FormFileModel.DEFAULT_UNIQUE_ID;
    };

    @action
    public fromDto(dto: RDDV2FileDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    public toDto(): RDDV2FileDTO {
        const rddV2FormFileModel: RDDV2FileDTO = {
            id: this.id,
            rddV2Id: this.rddV2Id,
            rddV2CategoryId: this.rddV2CategoryId,
            fileName: this.fileName,
            fileURL: this.fileURL,
            createdByUserId: this.createdByUserId,
            isDeleted: this.isDeleted,
            uniqueId: this.uniqueId,
        };

        return rddV2FormFileModel;
    }
}

export interface RDDV2FileDTO {
    id: string | null;
    rddV2Id: string | null;
    rddV2CategoryId: string | null;
    fileName: string;
    fileURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
    uniqueId: string | null;
}
